import { useCallback } from 'react';

import { Button, useHistoryPushWithBackAction } from '@dreryk/react-components';

import { visitPaths } from '~libs.desktop.shared.paths';

import { visitTranslationKeys } from '../../translations';

type VisitsHistoryButtonProps = {
   readonly patientId: number;
};

export const VisitsHistoryButton = (props: VisitsHistoryButtonProps): JSX.Element => {
   const push = useHistoryPushWithBackAction(true);
   const handleClick = useCallback(() => {
      push(
         visitPaths.getAppointmentsListPath({
            searchParams: {
               patientId: props.patientId,
            },
         }),
         {
            label: visitTranslationKeys.actionBar.goBackToPatientList,
         }
      );
   }, [props.patientId, push]);

   return (
      <Button
         testId={'visitsHistory'}
         label={visitTranslationKeys.patientVisits}
         type={'button'}
         onClick={handleClick}
      />
   );
};
